import React from "react";
import "./Loader.css";
import Chunk1 from "../../../assets/icons/loader_chunk_1.svg";
import Chunk2 from "../../../assets/icons/loader_chunk_2.svg";

const Loader = ({ text }) => {
  return (
    <div className="app-loader">
      <div className="loader-text">{text}</div>
      <div className="loader-container">
        <div className="loader-chunk-1">
          <img src={Chunk1} alt="Loader chunk 1" />
        </div>
        <div className="loader-chunk-2">
          <img src={Chunk2} alt="Loader chunk 2" />
        </div>
      </div>
    </div>
  );
};

export default Loader;
